import { LOCAL_STORAGE_REDIRECT_URL_LOGOUT } from 'shared/constants/localStorageVariables'

export const redirectWithUri = () => {
  const url = localStorage.getItem(LOCAL_STORAGE_REDIRECT_URL_LOGOUT)

  if (!url) {
    localStorage.removeItem(LOCAL_STORAGE_REDIRECT_URL_LOGOUT)
    window.location.reload()
    return
  }

  localStorage.removeItem(LOCAL_STORAGE_REDIRECT_URL_LOGOUT)
  window.location.replace(url)
}
